import classNames from 'classnames';
import React, { ChangeEvent, FC, FocusEvent } from 'react';

import { UnionIcon } from '@gem/icons';

import styles from './Checkbox.styles.m.css';

export enum CheckboxShape {
  Square = 'square',
  Round = 'round',
}

export interface ICheckboxProps {
  className?: string;
  isSemiChecked?: boolean;
  isChecked?: boolean;
  isDisabled?: boolean;
  onChange(value: boolean, e: ChangeEvent<HTMLInputElement>): void;
  onBlur?(e: FocusEvent<HTMLInputElement>): void;
  onFocus?(e: FocusEvent<HTMLInputElement>): void;
  shape?: CheckboxShape;
  id?: string;
  name?: string;
}

export const Checkbox: FC<ICheckboxProps> = ({
  className,
  isSemiChecked,
  isChecked = false,
  isDisabled = false,
  onChange,
  onBlur,
  onFocus,
  shape = CheckboxShape.Round,
  id,
  name,
}) => {
  let checkedType = 'not-selected';
  if (isSemiChecked || isChecked) {
    checkedType = isSemiChecked ? 'semi-selected' : 'selected';
  }
  const containerClassName = classNames(
    className,
    styles.container,
    { [styles.disabled]: isDisabled },
    styles[`shape-${shape}`],
    styles[checkedType]
  );

  return (
    <div className={containerClassName}>
      <div className={styles.checkboxWrapper}>
        <input
          id={id}
          name={name}
          type="checkbox"
          className={styles.checkbox}
          onChange={(event): void => onChange(event.target.checked, event)}
          onBlur={onBlur}
          onFocus={onFocus}
          checked={isChecked}
          disabled={isDisabled}
        />
        {checkedType === 'semi-selected' && <span className={styles.minusIcon} />}
        {checkedType === 'selected' && <UnionIcon />}
      </div>
    </div>
  );
};
